module.exports = __webpack_public_path__ + "img/produto-favorito.54f22967.svg";